<template>
  <div class="container px-4 py-3">
    <div v-show="featuredCompanies.length > 0" class="seo-section">
      <h1 style="text-align: justify !important">
        {{ this.$store.state.homeTitleX }}
      </h1>
      <h2 style="text-align: justify !important">
        {{ this.$store.state.homeDescriptionX }}
      </h2>
    </div>
    <hr v-show="featuredCompanies.length > 0" />
    <div
      v-if="
        this.$store.state.domainCustomVariablesX.filter(
          (q) => q.code == 'HomeBanner'
        ).length > 0
      "
    >
      <img
        class="w-100"
        v-bind:src="
          this.$store.state.domainCustomVariablesX.filter(
            (q) => q.code == 'HomeBanner'
          )[0].value
        "
        alt=""
      />
    </div>
    <hr
      v-show="
        this.$store.state.domainCustomVariablesX.filter(
          (q) => q.code == 'HomeBanner' && q.value != '' && q.value != undefined
        ).length > 0
      "
    />
    <div v-show="productsList.length > 0" class="row">
      <Carousel
        :autoplay="2000"
        :items-to-show="productsList.length > 5 ? 4.5 : 2.5"
        :wrap-around="true"
      >
        <Slide v-for="(product, pIndex) in productsList" :key="pIndex">
          <div class="carousel__item">
            <img
              :title="product.fullTitle"
              :src="'https://' + product.image"
              :alt="product.title"
            />
            <small :title="product.fullTitle" class="text-danger">{{
              product.title
            }}</small>
          </div>
        </Slide>

        <template #addons>
          <Navigation />
          <Pagination />
        </template>
      </Carousel>
    </div>
    <hr v-show="productsList.length > 0" />
    <div v-show="featuredCompanies.length > 0" class="row">
      <h3>{{ this.$store.getters.getWordLocale("txt_firma_listesi") }}</h3>
      <div
        v-for="(company, cIndex) in featuredCompanies"
        :key="cIndex"
        :class="
          featuredCompanies.length > 5
            ? cIndex == 6
              ? 'col-md-12 mt-4'
              : 'col-md-4 mt-4'
            : 'col-md-12 mt-2'
        "
      >
        <div class="card company-card">
          <div class="card-header">
            <img class="company-logo" :src="company.logo" alt="as" />
            <b class="ms-2">
              <router-link
                :companyId="company.id"
                :to="
                  '/' + this.$store.state.langCodeX + '/company/' + company.link
                "
              >
                <b :title="company.fullName"> {{ company.name }} </b>
              </router-link>
            </b>
          </div>
          <div class="card-body">
            <div
              v-show="this.$store.state.domainLanguages.length > 1"
              class="languages"
            >
              <router-link
                v-for="(profile, lIndex) in company.languages"
                :key="lIndex"
                :companyId="company.id"
                :to="'/' + profile + '/company/' + company.link"
              >
                <country-flag
                  :class="
                    this.$store.state.langCodeX == profile
                      ? 'selected-lang header-language'
                      : 'header-language'
                  "
                  v-show="
                    this.$store.state.domainLanguages.filter(
                      (q) => q.LangCode == profile
                    ).length > 0
                  "
                  :country="
                    profile == 'en' ? 'gb' : profile == 'ar' ? 'sa' : profile
                  "
                  size="normal"
                />
              </router-link>
            </div>

            <div class="row ms-1">
              {{ company.description }}
            </div>
          </div>
        </div>
      </div>

      <div>
        <router-link
          class="btn btn-danger mt-2 go-to-link"
          :to="'/' + this.$store.state.langCodeX + '/companies'"
          >{{ this.$store.getters.getWordLocale("txt_firma_listesine_git") }}
          <i class="fa fa-arrow-right"></i>
        </router-link>
      </div>
    </div>

    <hr />
  </div>

  <div class="container px-4">
    <div v-show="featuredLeads.length > 0" class="container seo-section">
      <h1>{{ this.$store.getters.getWordLocale("txt_talep_listesi_desc") }}</h1>
      <h2>{{ this.$store.getters.getWordLocale("txt_talep_listesi_h3") }}</h2>
    </div>

    <hr v-show="featuredLeads.length > 0" />
    <div v-show="featuredLeads.length > 0" class="row">
      <h3>{{ this.$store.getters.getWordLocale("txt_talep_listesi") }}</h3>
      <div
        v-for="(lead, leadIndex) in featuredLeads"
        :key="leadIndex"
        :class="featuredLeads.length > 5 ? 'col-md-12 mt-2' : 'col-md-12 mt-2'"
      >
        <div class="card">
          <div class="card-header row">
            <div class="col-md-9">
              <div class="d-flex">
                <country-flag
                  class="me-0"
                  :country="lead.countryCode"
                  size="normal"
                />
                <b class="ms-2 mt-2">
                  <router-link
                    :to="
                      '/' + this.$store.state.langCodeX + '/lead/' + lead.link
                    "
                    ><b> {{ lead.title }} </b></router-link
                  >
                </b>
              </div>
            </div>
            <div class="col-md-3">
              <small class="float-end lead-time badge bg-dark">
                {{ lead.createTime }}
              </small>
            </div>
          </div>
          <div class="card-body">
            <div class="row ms-1">
              {{ lead.summary }}
            </div>
          </div>

          <div class="card-footer">
            <div class="lead-info d-flex">
              <div class="lead-type mt-2 ms-2">
                <small :class="lead.leadType == 0 ? 'buy' : 'sell'">
                  {{
                    lead.leadType == 0
                      ? this.$store.getters.getWordLocale("txt_alim_talebi")
                      : lead.leadType == 1
                      ? this.$store.getters.getWordLocale("txt_satis_teklifi")
                      : this.$store.getters.getWordLocale("txt_isbirligi")
                  }}
                </small>
              </div>
              <div class="separator"></div>
              <div v-if="lead.credit > 0" class="lead-credit not-free">
                <i class="fas fa-coins"></i> {{ lead.credit }}
              </div>
              <div v-else class="lead-credit free">
                <i class="fas fa-handshake"></i>
                {{ this.$store.getters.getWordLocale("txt_ucretsiz") }}
              </div>
              <div class="separator"></div>
              <div class="lead-country d-flex">
                <country-flag :country="lead.countryCode" size="small" />
                <small>{{ lead.countryName }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <router-link
          class="btn btn-danger mt-2 go-to-link"
          :to="'/' + this.$store.state.langCodeX + '/leads'"
          >{{ this.$store.getters.getWordLocale("txt_talep_listesine_git") }}
          <i class="fa fa-arrow-right"></i>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import CountryFlag from "vue-country-flag-next";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import { mapState } from "vuex";
import moment from "moment";

export default {
  computed: mapState({
    isSearchChangedX: (state) => state.isSearchChangedX,
    langCodeX: (state) => state.langCodeX,
  }),
  watch: {
    isSearchChangedX(newVal) {
      if (newVal == true) {
        this.searchText = this.$store.state.searchInputValueX;
      }
    },
    langCodeX() {
      this.homePageLists();
    },
  },
  props: ["keyword"],
  components: {
    CountryFlag,
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  data() {
    return {
      productsList: [
        {
          image: "",
          title: "",
          description: "",
        },
      ],
      featuredCompanies: [],
      featuredLeads: [],
      profiles: ["tr", "en"],
      hasCompanies: false,
      hasLeads: false,
      hasProducts: false,
      contentCount: 0,
      domainName: "",
    };
  },
  methods: {
    goToCompanyDetails(langCode, link) {
      this.$store.state.langCodeX = langCode;
      this.$router.push({ path: `/company/${link}` });
    },
    homePageLists() {
      if (this.$store.state.featuredCompaniesX.length > 0) {
        this.$store.state.featuredCompaniesX =
          this.$store.state.featuredCompaniesX.sort(() => 0.5 - Math.random());

        this.featuredCompanies = [];
        this.productsList = [];
        this.$store.state.featuredCompaniesX.forEach((element) => {
          if (this.featuredCompanies.length == 7) {
            return 0;
          }
          var name =
            element.name.length > 30
              ? `${element.name.substr(0, 30)}...`
              : element.name;

          var fullName = element.name;

          var logo =
            element.logo == null
              ? this.$store.state.defaultLogoX
              : `https://cdn.turkishexporter.com.tr${element.logo}`;

          logo = logo.toLowerCase();
          if (
            logo.indexOf(`companies/logo/1`) != -1 ||
            logo.indexOf(`companies/logo/logo`) != -1
          ) {
            logo = this.$store.state.defaultLogoX;
          }

          var charCount = 110;
          if (
            this.featuredCompanies.length == 6 ||
            this.$store.state.featuredCompaniesX.length < 6
          ) {
            charCount = 450;
          }

          var companyDescription =
            element.localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length > 0
              ? element.localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].DescriptionContent
              : element.localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].DescriptionContent;
          companyDescription =
            companyDescription == null
              ? ""
              : companyDescription.length > charCount
              ? `${companyDescription.substr(0, charCount)}...`
              : companyDescription;

          var languages = [];
          element.localizations.forEach((loc) => {
            languages.push(loc.LangCode);
          });

          element.products.forEach((pro) => {
            var image = pro.Images.length == 0 ? "" : pro.Images[0];
            var title =
              pro.Localizations.length == 0
                ? ""
                : pro.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  ).length > 0
                ? pro.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  )[0].Name
                : pro.Localizations.filter(
                    (q) => q.LangCode != this.$store.state.langCodeX
                  )[0].Name;
            title = title.length > 20 ? `${title.substr(0, 20)}...` : title;
            var fullTitle =
              pro.Localizations.length == 0
                ? ""
                : pro.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  ).length > 0
                ? pro.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  )[0].Name
                : pro.Localizations.filter(
                    (q) => q.LangCode != this.$store.state.langCodeX
                  )[0].Name;

            var description =
              pro.Localizations.length == 0
                ? ""
                : pro.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  ).length > 0
                ? pro.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  )[0].Description
                : pro.Localizations.filter(
                    (q) => q.LangCode != this.$store.state.langCodeX
                  )[0].Description;

            if (image != "" && image != undefined) {
              this.productsList.push({
                image: image,
                fullTitle: fullTitle,
                title: title,
                description: description,
              });
            }
          });
          var link = element.link;

          this.featuredCompanies.push({
            link: link,
            logo: logo,
            name: name,
            fullName: fullName,
            description: companyDescription,
            languages: languages,
          });
        });
      } else {
        this.productsList = [];
      }

      if (this.$store.state.featuredLeadsX.length > 0) {
        this.featuredLeads = [];

        this.$store.state.featuredLeadsX.forEach((element) => {
          var leadTitle =
            element.localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length > 0
              ? element.localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Title
              : element.localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Title;

          var createTime = element.createTime;

          var endDate = moment(new Date()).format("DD.MM.YYYY HH:mm:ss");
          endDate = moment(endDate, "DD.MM.YYYY HH:mm:ss");
          createTime = moment(createTime, "DD.MM.YYYY HH:mm:ss");

          var diff = endDate.diff(createTime, "days");
          if (diff == 0) {
            createTime = moment(createTime, "DD.MM.YYYY HH:mm:ss").fromNow();
          } else {
            createTime = element.createTime;
          }

          var leadId = parseInt(element.id);
          var leadType = parseInt(element.leadType);
          var credit = parseInt(element.credit);
          var countryName =
            element.country.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length == 0
              ? element.country.filter((q) => q.LangCode == "en").length == 0
                ? element.country.filter(
                    (q) => q.LangCode != this.$store.state.langCodeX
                  )[0].Name
                : element.country.filter((q) => q.LangCode == "en")[0].Name
              : element.country.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Name;
          var countryCode =
            element.country[0] != null && element.country[0] != undefined
              ? element.country[0].Icon
              : "";

          var leadSummary =
            element.localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length > 0
              ? element.localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].ShortDescription
              : element.localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].ShortDescription;
          leadSummary =
            leadSummary == null
              ? ""
              : leadSummary.length > 150
              ? `${leadSummary.substr(0, 150)}...`
              : leadSummary;

          var leadKeywords =
            element.localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length > 0
              ? element.localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Keywords
              : element.localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Keywords;

          var languages = [];
          element.localizations.forEach((loc) => {
            languages.push(loc.LangCode);
          });
          leadKeywords = leadKeywords.split(",");
          var link = element.link;
          this.featuredLeads.push({
            id: leadId,
            title: leadTitle,
            link: link,
            createTime: createTime,
            countryName: countryName,
            countryCode: countryCode !== null ? countryCode.toLowerCase() : "",
            summary: leadSummary,
            keywords: leadKeywords,
            languages: languages,
            leadType: leadType,
            credit: credit,
          });
        });
      }
    },
  },
  mounted() {
    moment.locale(`${this.$store.state.langCodeX}`);
    this.homePageLists();
    this.domainName = this.$store.state.domainContentX.DomainName;
    var filterContent = this.$store.state.domainContentX.FilterContent;

    this.contentCount = 0;
    this.hasCompanies =
      filterContent.filter(
        (q) =>
          q.id == "1" && parseInt(q.status) == 1
      ).length > 0
        ? true
        : false;

    this.hasLeads =
      filterContent.filter(
        (q) =>
          q.id == "2" && parseInt(q.status) == 1
      ).length > 0
        ? true
        : false;

    this.hasProducts =
      filterContent.filter(
        (q) =>
          q.id == "3" && parseInt(q.status) == 1
      ).length > 0
        ? true
        : false;

    if (this.hasCompanies) {
      this.contentCount = this.contentCount + 1;
    }

    if (this.hasLeads) {
      this.contentCount = this.contentCount + 1;
    }

    if (this.hasProducts) {
      this.contentCount = this.contentCount + 1;
    }
  },
};
</script>

<style scoped>
.feature-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  margin-bottom: 1rem;
  font-size: 2rem;
  color: #fff;
  border-radius: 0.75rem;
}

.desc-text {
  min-height: 125px;
}

.go-to-link {
  float: right;
  width: 100%;
}

.company-logo {
  width: 60px;
  height: 60px;
  border: 1px solid #d8d8d8;
  padding: 2px;
  margin: 2px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.languages {
  border: 1px solid #ffffff;
  border-radius: 4px;
  background: #f7f7f7;
  margin-left: 2px;
  margin-right: 2px;
  margin-bottom: 8px;
}

.carousel button {
  background-color: #000 !important;
}
.carousel__item {
  max-height: 150px;
  width: 100%;
  background-color: #f7f7f7;
  color: var(--vc-clr-white);
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}

.carousel__pagination-button--active {
  background-color: red !important;
}

.carousel__item img {
  width: 130px;
  height: 130px;
}

.separator {
  margin-top: 7px;
  margin-left: 7px;
}

.lead-country small {
  margin-top: 9px;
  margin-left: 4px;
  font-weight: 900;
}

.separator {
  margin-top: 7px;
  margin-left: 7px;
}

.sell {
  color: #34c5f3 !important;
  border: 1px solid #34c5f3 !important;
  margin-right: 3px;
  font-size: 12px;
  padding: 6px 10px;
}

.buy {
  color: #e71d36 !important;
  border: 1px solid #e71d36 !important;
  font-size: 12px;
  margin-right: 3px;
  padding: 6px 10px;
}

.not-free {
  min-width: 50px;
  text-align: center;
  margin-top: 5px;
  color: #daa520 !important;
  border: 1px solid #daa520 !important;
  font-size: 12px;
  margin-right: 3px;
  padding: 6px 10px;
  height: 31px;
}

.free {
  min-width: 50px;
  text-align: center;
  margin-top: 5px;
  color: #16a448 !important;
  border: 1px solid #16a448 !important;
  font-size: 12px;
  margin-right: 3px;
  padding: 6px 10px;
  height: 31px;
}

.seo-section {
  border: 0px;
  border-radius: 4px;
  color: #202428;
  background-color: #ffffff;
  padding: 8px;
}

.company-card {
  min-height: 245px;
}
</style>